import React from 'react';
import Pricing from '../components/Pricing';

const PricingPage = () => {
  return (
    <div className="min-h-screen bg-neutral-50">
      <section className="bg-gradient-to-r from-primary-600 to-primary-800 text-white py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">FASTag Pricing</h1>
            <p className="text-xl text-primary-100">
              Transparent, Affordable, No Hidden Charges
            </p>
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto mb-12">
            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-white rounded-xl shadow-lg p-6 text-center">
                <div className="bg-primary-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold mb-2 text-neutral-900">All-Inclusive</h3>
                <p className="text-neutral-700">One-time payment covers tag, deposit, and initial balance</p>
              </div>

              <div className="bg-white rounded-xl shadow-lg p-6 text-center">
                <div className="bg-secondary-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-8 h-8 text-secondary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold mb-2 text-neutral-900">Refundable Deposit</h3>
                <p className="text-neutral-700">₹200 fully refundable when you close your FASTag account</p>
              </div>

              <div className="bg-white rounded-xl shadow-lg p-6 text-center">
                <div className="bg-primary-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold mb-2 text-neutral-900">Instant Activation</h3>
                <p className="text-neutral-700">Start using your FASTag immediately after receiving it</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Pricing />

      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-center mb-12 text-neutral-900">Frequently Asked Questions</h2>

            <div className="space-y-6">
              <div className="bg-neutral-50 rounded-lg p-6">
                <h3 className="text-xl font-semibold mb-3 text-neutral-900">
                  Is the ₹200 security deposit really refundable?
                </h3>
                <p className="text-neutral-700">
                  Yes, absolutely! The ₹200 security deposit is 100% refundable when you close or surrender your
                  FASTag account, provided there are no outstanding dues or penalties.
                </p>
              </div>

              <div className="bg-neutral-50 rounded-lg p-6">
                <h3 className="text-xl font-semibold mb-3 text-neutral-900">
                  Are there any delivery charges?
                </h3>
                <p className="text-neutral-700">
                  Delivery charges may vary depending on your location and typically range from ₹50-₹100.
                  These charges will be clearly communicated during checkout before you confirm your order.
                </p>
              </div>

              <div className="bg-neutral-50 rounded-lg p-6">
                <h3 className="text-xl font-semibold mb-3 text-neutral-900">
                  Can I recharge my FASTag later?
                </h3>
                <p className="text-neutral-700">
                  Yes! You can recharge your FASTag wallet anytime through multiple channels - bank apps, UPI,
                  online banking, or through our agent network. Minimum recharge amount may vary by bank.
                </p>
              </div>

              <div className="bg-neutral-50 rounded-lg p-6">
                <h3 className="text-xl font-semibold mb-3 text-neutral-900">
                  What's the difference between SBI and IDFC FASTag?
                </h3>
                <p className="text-neutral-700">
                  Both SBI and IDFC First Bank FASTags work identically at all toll plazas across India. The
                  pricing structure is the same (₹400 total). You can choose based on your preference or which
                  bank you already have an account with for easier recharges.
                </p>
              </div>

              <div className="bg-neutral-50 rounded-lg p-6">
                <h3 className="text-xl font-semibold mb-3 text-neutral-900">
                  What if my FASTag gets damaged or lost?
                </h3>
                <p className="text-neutral-700">
                  In case of damage or loss, you can request a replacement FASTag. A replacement fee may apply
                  (typically around ₹100), but your account balance and deposit remain protected. Contact our
                  support team for assistance with replacements.
                </p>
              </div>

              <div className="bg-neutral-50 rounded-lg p-6">
                <h3 className="text-xl font-semibold mb-3 text-neutral-900">
                  Do I need a bank account to get a FASTag?
                </h3>
                <p className="text-neutral-700">
                  Yes, you'll need to link your FASTag to a bank account or wallet for automatic toll deductions
                  and recharges. This can be a savings account, current account, or prepaid wallet depending on
                  the issuer bank's options.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-gradient-to-br from-primary-600 to-primary-800">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center text-white">
            <h2 className="text-3xl md:text-4xl font-bold mb-6">Ready to Get Started?</h2>
            <p className="text-xl mb-8 text-primary-100">
              Order your FASTag today and enjoy hassle-free toll payments across India
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <a
                href="/#customer-form"
                className="bg-white text-primary px-8 py-4 rounded-lg font-semibold hover:bg-primary-50 transition shadow-lg"
              >
                Order FASTag Now
              </a>
              <a
                href="/contact"
                className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg font-semibold hover:bg-white hover:text-primary transition"
              >
                Have Questions? Contact Us
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PricingPage;
